// extracted by mini-css-extract-plugin
export default {"IssueMetadataSection_container":"styles_IssueMetadataSection_container__e46XD","bold":"styles_bold__96bQZ","item":"styles_item__Hj-+V"};